import { action } from 'satcheljs';
export default action('UPDATE_FOLDER_COUNTS', function (unreadCount, totalCount, folderId, isDeltaChange) {
    return {
        unreadCount: unreadCount,
        totalCount: totalCount,
        folderId: folderId,
        isDeltaChange: isDeltaChange,
    };
});
//# sourceMappingURL=updateFolderCounts.js.map